import { Feature, hasFeature } from '@fytness/shared';
import { usePurchases } from '~/purchases/contexts/purchases/Purchases';

/**
 * Whether the current user can use a gated plan {@link Feature}, using the shared
 * subsumption-aware `hasFeature` over their active RevenueCat entitlements. This is the
 * single client-side gate — the same `Feature` map is enforced on the backend.
 *
 * @example
 * const canCustomFoods = useHasFeature(Feature.CUSTOM_FOODS);
 */
export const useHasFeature = (feature: Feature): boolean => {
  const { activeEntitlements } = usePurchases();
  return hasFeature(activeEntitlements, feature);
};
